webpackJsonp([241098541384509],{

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(575);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgettoPage = function (_Component) {
	  _inherits(ProgettoPage, _Component);
	
	  function ProgettoPage() {
	    _classCallCheck(this, ProgettoPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProgettoPage.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Il Centro Studi | ',
	          data.site.siteMetadata.title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'wrap-narrower' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'text-primary mb-3' },
	          'Il Centro Studi'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'Progetto__CoverImage constant-ratio constant-ratio--21-9' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          sizes: data.imageCentro.childImageSharp.sizes,
	          style: {
	            position: 'absolute',
	            left: 0,
	            width: '100%',
	            top: '50%',
	            height: '100%',
	            transform: 'translateY(-50%)'
	          }
	        })
	      ),
	      _react2.default.createElement('div', {
	        className: 'Progetto__Abstract wrap-narrower',
	        dangerouslySetInnerHTML: {
	          __html: data.allDatoCmsPaginaIlProgetto.edges[0].node.contenuto
	        }
	      })
	    );
	  };
	
	  return ProgettoPage;
	}(_react.Component);
	
	exports.default = ProgettoPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-centro-js-67e22f1bb2c183aee7a9.js